import { render, staticRenderFns } from "./editable_trip.vue?vue&type=template&id=5ae43064&scoped=true&"
import script from "./editable_trip.vue?vue&type=script&lang=js&"
export * from "./editable_trip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae43064",
  null
  
)

export default component.exports